import React, {useEffect, useRef} from "react";
import {useDispatch} from "react-redux";
import { loadModelAction } from "store/actions/modal";
import { RESET_TABLE } from "store/constans";
import { useDashboardState } from "components/DashboardContext";

import { loadModel } from "utils/builder/ITestLogic";
import { resizeViewer } from "utils/builder/ITestLogic";
import classNames from "classnames";
import "./EditorSection.scss";

import UniversalButton from "components/uiComponents/UniversalButton";

import { ReactComponent as ChangeHeightIcon } from "static/icons/multiselection.svg";
import { runTest } from "../../utils/builder/ITestLogic";
import { getTabs } from "../../store/actions/table";

const EditorSection = ({
    autodesk,
    projectData,
    table
}) => {
    const dispatch = useDispatch();
    const viewer = useRef();

    const {
        isTableHidden,
        setIsTableHidden,
        setIsModalLoaded,
    } = useDashboardState();

    useEffect(() => {
        setTimeout(() => {
            resizeViewer();
        }, 510);
    }, [isTableHidden]);

    const handleHideTable = () => {
        setIsTableHidden(!isTableHidden);
    };

    const callback = (res) => {
        setIsModalLoaded({ status: true });

        const categories = JSON.parse(localStorage.getItem("categories"));

        runTest(categories.discipline, categories.stage)
          .then((res) => {
            dispatch(loadModelAction(res));
            dispatch(getTabs(res.tables));
        });
    };

  useEffect(() => {
      if (
          projectData &&
          viewer.current &&
          autodesk &&
          viewer.current.children.length < 1
      ) {
          dispatch({
              type: RESET_TABLE,
          });

          loadModel(projectData, callback, viewer.current);
      }
  }, [
      viewer.current,
      projectData,
      autodesk,
  ]);

  return (
      <div className="editor-section">
          <div className="editor-section__body">
            {
              (!!table.tabs.length) &&
              <div className="editor-section__height-button">
                <UniversalButton
                  centerIcon={<ChangeHeightIcon />}
                  size="lg"
                  labelColor="white"
                  labelHoverColor="white"
                  backgroundColor={isTableHidden ? "blue-dark" : "gray6"}
                  backgroundHoverColor={isTableHidden ? "blue-light" : "gray5"}
                  onClick={handleHideTable}
                />
              </div>
            }

              <div
                  className={classNames({
                      "editor-section__viewer": true,
                      "editor-section__viewer--short": !isTableHidden,
                  })}
                  ref={viewer}
              />
          </div>
      </div>
  );
};

export default EditorSection;
